<template>
  <div
    class="carousel"
    :class="{'game-type': gameLobby}"
  >
    <!-- 首頁 V1：同一批 banner 改成一次多張的橫向列（切版 home-v1 頂部，樣式見 refresh/home-layout-v1.css） -->
    <template v-if="rail && carousel.length !== 0">
      <div ref="rail" class="home-banner-rail" @scroll.passive="updateRailArrows">
        <a
          v-for="(item, key) in carousel"
          :key="key"
          @click="goLink(isMobile() ? item.link : item.pc_link, item.open_type)"
        >
          <img
            :src="isMobile() ? item.image : item.pc_image"
            :alt="isMobile() ? item.link : item.pc_link"
            :loading="key < 3 ? null : 'lazy'"
          >
        </a>
      </div>
      <button
        v-for="direction in [-1, 1]"
        :key="direction"
        type="button"
        class="home-banner-rail-arrow"
        :class="direction < 0 ? 'is-prev' : 'is-next'"
        :disabled="direction < 0 ? !railCanPrev : !railCanNext"
        :aria-label="direction < 0 ? 'previous' : 'next'"
        @click="scrollRail(direction)"
      />
    </template>
    <VueSlickCarousel v-else-if="carousel.length !== 0" class="carousel slider index-slick" v-bind="slick_setting" :arrows="false">
      <a
        v-for="(item, key) in carousel"
        :key="key"
        class="d-block"
        @click="goLink(isMobile() ? item.link : item.pc_link, item.open_type)"
      >
        <img
          :src="isMobile() ? item.image : item.pc_image"
          :alt="isMobile() ? item.link : item.pc_link"
        >
      </a>
    </VueSlickCarousel>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import { detectMob } from '@/utils/tool'

export default {
  components: {
    VueSlickCarousel
  },
  props: {
    // true：改用一次多張的橫向列（首頁 V1），false：原本一次一張的淡入輪播
    rail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      railCanPrev: false,
      railCanNext: false,
      carousel: [],
      slick_setting: {
        pauseOnHover: true,
        adaptiveHeight: false,
        dots: true,
        infinite: true,
        draggable: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        initialSlide: 0,
        fade: true,
        cssEase: 'linear'
      }
    }
  },
  computed: {
    brand() {
      return this.$store.state.brand
    },
    user() {
      return this.$store.state.user
    },
    currentGameCategory() {
      return this.user.currentGameCategory
    },
    currentGameProvider() {
      return this.user.currentGameProvider
    },
    activeFilter() {
      return this.user.activeFilter
    },
    gameLobby() {
      return this.brand.showSearch || this.brand.showProvider ||
      this.currentGameCategory || this.currentGameProvider ||
      this.activeFilter === 'favorites'
    }
  },
  watch: {
    '$store.state.brand.carousel': {
      handler(newVal) {
        if (newVal) {
          this.carousel = newVal
        }
      },
      immediate: true
    },
    carousel() {
      this.$nextTick(this.updateRailArrows)
    },
    rail() {
      this.$nextTick(this.updateRailArrows)
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.brand.carousel.length) {
        this.carousel = this.brand.carousel
      }
    })
  },
  mounted() {
    window.addEventListener('resize', this.updateRailArrows)
    this.$nextTick(this.updateRailArrows)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateRailArrows)
  },
  methods: {
    // 箭頭在捲到頭／尾時停用
    updateRailArrows() {
      const rail = this.$refs.rail
      if (!rail) return
      this.railCanPrev = rail.scrollLeft > 2
      this.railCanNext = rail.scrollLeft < rail.scrollWidth - rail.clientWidth - 2
    },
    // 一次翻過目前畫面上看得到的張數
    scrollRail(direction) {
      const rail = this.$refs.rail
      if (!rail || !rail.children.length) return
      const step = rail.children[0].getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0)
      const visible = Math.max(1, Math.round(rail.clientWidth / step))
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      rail.scrollBy({ left: direction * step * visible, behavior: reduced ? 'auto' : 'smooth' })
    },
    isMobile() {
      return detectMob()
    },
    goLink(link, open_type) {
      if (link === 'pop_register') {
        this.$store.commit('SET_REGISTER_OPEN', true)
      } else {
        window.open(link, open_type)
      }
    }
  }
}
</script>

<style>
.slick-dots {
  bottom: 10px;
}

.index-slick .slick-slide {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0;
  transition: opacity 1s cubic-bezier(.19,1,.22,1), transform 2s cubic-bezier(.19,1,.22,1);
}
.index-slick .slick-slide.slick-current {
  opacity: 1;
  z-index: 1;
}
.index-slick .slick-dots li button::before {
  opacity: 1;
  color: #fff;
  width: 15px;
  height: auto;
  font-size: 12px;
  transform: scale(.8);
  opacity: .8;
  transition: 1.6s cubic-bezier(.19,1,.22,1);
  cursor: pointer;
}

.index-slick .slick-dots li.slick-active button:before {
  color: #b1a781;
  transform: scale(1);
  opacity: 1;
}

.index-slick .slick-slide a {
  position: relative;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
}
.index-slick .slick-slide a img {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transform: scale(1.4);
  opacity: 0;
  transition: opacity 1s cubic-bezier(.19,1,.22,1),transform 2s cubic-bezier(.19,1,.22,1);
}
.index-slick  .slick-slide.slick-active a img {
    transform: scale(1);
    opacity: 1;
}

@media only screen and (max-width: 992px) {
  .index-slick .slick-slide a img {
    max-height: 516px;
  }
}

@media only screen and (max-width: 500px) {
  .index-slick .slick-slide a img {
      width: 100%;
      max-height: 350px;
  }
}
</style>
